import { createStore } from 'vuex';

const store = createStore({
    state: {
        accessToken: localStorage.getItem('accessToken') || null,
        refreshToken: localStorage.getItem('refreshToken') || null
    },
    mutations: {
        saveAccessToken(state, access) {
            state.accessToken = access;
        },
        saveRefreshToken(state, refresh) {
            state.refreshToken = refresh;
        },
        logout(state) {
            state.accessToken = null;
            state.refreshToken = null;
        }
    },
    actions: {
        login({ commit }, { access, refresh }) {
            commit('saveAccessToken', access);
            commit('saveRefreshToken', refresh);
            localStorage.setItem('accessToken', access);
            localStorage.setItem('refreshToken', refresh);
        },
        logout({ commit }) {
            commit('logout');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
        }
    }
});

export default store;